import { render, staticRenderFns } from "./Help2.vue?vue&type=template&id=85b48a7e&"
import script from "./Help2.vue?vue&type=script&lang=js&"
export * from "./Help2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports